import React from 'react'
import type { Icon } from 'shared/utils'
import { colors } from 'shared/assets/styles'

const { mayoEggWhite } = colors

const Star = (props: Icon) => {
    const { size = 12, color = mayoEggWhite } = props
    return (
        <svg width={size} height={size} viewBox="0 0 12 12" fill="none">
            <path
                d="M2.98117 9.00772C3.71074 8.82213 4.36032 8.41255 5.05789 8.13736C5.39387 8.58534 5.70426 9.06852 5.99225 9.5581C5.99225 9.5645 5.99225 9.5581 5.99545 9.5645C6.26744 10.0893 6.62582 10.5661 7.0418 10.4925C7.40979 10.4285 7.62738 9.98368 7.67538 9.4877C7.74897 8.73574 7.78737 7.91337 7.73618 7.1582C8.21935 7.01421 8.89133 6.69742 9.4065 6.49263C10.2641 6.15344 10.3057 4.9375 9.21131 4.8031C8.65454 4.7327 8.04016 4.63991 7.56338 4.43832C7.51858 3.67675 7.50898 3.14557 7.36179 2.3968C7.1538 1.33445 6.30583 1.23525 5.80666 1.99682L4.56191 3.73435C4.03393 3.60635 3.50595 3.47196 2.97798 3.34396C2.37 3.19677 2.02442 3.44316 1.85482 3.86234C1.67243 4.31352 1.97642 4.7999 2.3124 5.05269C2.61959 5.28628 2.91718 5.53587 3.20517 5.79186C2.95558 6.35504 2.52359 7.08781 2.05641 7.68618C1.45484 8.45735 2.03082 9.24771 2.98117 9.00452V9.00772Z"
                fill={color}
            />
        </svg>
    )
}

export { Star }
